var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-select',{attrs:{"label":"Invoice Month","items":_vm.items,"value":_vm.value},on:{"input":_vm.onChangeMonth}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }